const { isEmptyObject } = require('utilities/common');

export function productValidations(product) {
    const errors = {};

    // Validate productName
    if (!product.productName) {
        errors.productName = 'Product name is required';
    }
    if (!product.brandName) {
        errors.brandName = 'Brand name is required';
    }
    if (product?.ingredientStatus && !product?.ingredients) {
        errors.ingredients = 'Product Ingredients is required';
    }
    if (!product?.categoryName) {
        errors.categoryName = 'Category Name is required';
    }
    // if (product?.instructionStatus && !product?.instructions) {
    //     errors.instructions = 'Product Instructions is required';
    // }
    // if (product?.salePrice === '' || product?.salePrice === null || product?.salePrice === undefined || product?.salePrice === 0) {                                                 
    //     errors.salePrice = 'Sale price is required';
    // }
    
      if (product?.unitPrice === '' || product?.unitPrice === null || product?.unitPrice === undefined || product?.unitPrice === 0) {
        errors.unitPrice = 'Unit price is required';
    }

    if ((product?.unitPrice && product?.salePrice) && +product?.salePrice > +product?.unitPrice) {
        errors.salePrice = 'Sale price cannot be greater than unit price';
    }

    if ((product?.isSample || product?.isPromo || product?.isDisplay) && (product?.samplePrice === '' || product?.samplePrice === null || product?.samplePrice === undefined || +product?.samplePrice === 0)) {
        errors.samplePrice = 'Sample price cannot be zero or empty';
    }
//  if (product?.isStilo && !product.metaTitle) {
//         errors.metaTitle = 'Meta Title is required!';
//     }

//     if (product?.isStilo && !product.metaDescription) {
//         errors.metaDescription = 'Meta Description is required!';
//     }
     return { errors, isValid: isEmptyObject(errors) };
}
